

/*
 * 地块、楼栋、楼层图形区的共享状态
 */

import { useState } from "react";
import { ModelBase } from "pytha";

export interface BimStatus {
    globalEntityDict: { [key: string]: ModelBase }
    setGlobalEntityDict: (entities: { [key: string]: ModelBase }) => void

    putGlobalEntityDict: (entityDict: { [key: string]: ModelBase }) => void
}

export function useBimService() {
    const [currentLevel, setCurrentLevel] = useState<number>(); // 当前模型的层级
    const [globalEntityDict, setGlobalEntityDict] = useState<{ [key: string]: ModelBase }>({});  // 全局图元

    const putGlobalEntityDict = (entityDict: { [key: string]: ModelBase }) => {
        if (!entityDict) return;
        setGlobalEntityDict({ ...globalEntityDict, ...entityDict });
    }

    return {
        currentLevel, setCurrentLevel,
        globalEntityDict, setGlobalEntityDict,
        putGlobalEntityDict,
    }
}